
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, MessageSquare } from 'lucide-react';

export default function TopicDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-8">
      <div className="container-custom">
        <div className="flex items-center gap-4 mb-6">
          <Button 
            variant="outline" 
            onClick={() => navigate('/community')}
            className="flex items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back to Community
          </Button>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <MessageSquare size={20} />
              Topic Details
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="py-8 text-center">
              <MessageSquare className="mx-auto h-12 w-12 text-gray-300 mb-2" />
              <p className="text-gray-500">Topic details coming soon!</p>
              <p className="text-gray-400 text-sm mt-2">
                Full topic discussions will be available here
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
